import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useAuthStore } from '../../store'

/**
 * 允许访客模式访问的路由保护组件
 * 访客可以访问所有页面，但金额相关数据会显示为0
 * 需要完整数据时会提示用户登录
 */
export default function ProtectedRoute() {
  /*
   * 注释保留，不是删除 —— 这是「路由层直接拦」那套方案的入口。
   *
   * 现状是访客模式：本组件刻意不重定向（见下方 return <Outlet />），游客能进受保护页
   * 看结构、金额脱敏并被引导登录。真正拦人的是 api.js 的 401 拦截器（它自己带
   * ?redirect=）；用户主动点登录由 hooks/useGoLogin 带 state.from。
   *
   * 若日后改为「未登录不渲染、直接跳登录页」，放开下面两行即可：
   *     const location = useLocation()
   *     if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />
   * 同时要把 react-router-dom 的 useLocation / Navigate 加回导入，
   * 并接受访客模式的软引导随之失效。
   */
  const { isLoading, init } = useAuthStore()

  useEffect(() => {
    init()
  }, [init])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="loading-spinner mx-auto mb-4" style={{ width: 40, height: 40 }} />
          <p className="text-gray-500">加载中...</p>
        </div>
      </div>
    )
  }

  // 访客模式：允许访问所有页面，页面内部会根据认证状态处理金额显示
  return <Outlet />
}
